import { LicenseInfo } from '@mui/x-license';
export function initRubiksLicense() {
    LicenseInfo.setLicenseKey('ac52a561ebfd643539a9528ed0a0f368Tz0xMjk0MTcsRT0xODEyOTMxMTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=');
}
